export enum AuthRoles {
  SuperAdmin = "SuperAdmin",
  Admin = "Admin",
  CustomerManager = "CustomerManager",
  CustomerAgent = "CustomerAgent",
  ProviderAgent = "ProviderAgent",
  UnknownTelegramUser = "UnknownTelegramUser",
}

export type AuthUser = {
  id: string;
  firstName: string;
  lastName: string;
  fullName?: string;
  accessToken: string;
  email: string;
  role: AuthRoles;
  isTwoFactorAuthEnabled: boolean;
  customerId?: string;
  providerId?: string;
  isManagement?: boolean;
};
